module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Eldon Ladd\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" George Eldon Ladd (1911–1982) was professor of New Testament exegesis and theology at Fuller Theological Seminary, Pasadena, California. His numerous books include "), _c('I', [_vm._v("The New Testament and Criticism, A Commentary on the Revelation of John")]), _vm._v(", and "), _c('I', [_vm._v("Theology of the New Testament.")]), _vm._v("\"")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bBL2ZS/tc-custom/9781467460422.jpg?1742010487495",
      "alt": "This image is the cover for the book A Theology of the New Testament"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Theology of the New Testament\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ladd's magisterial work on New Testament theology has well served thousands of seminary students since its publication in 1974. Enhanced and updated here by Donald A Hagner, this comprehensive, standard evangelical text now features augmented bibliographies and two completely new chapters on subjects that Ladd himself wanted to treat in a revised edition—the theology of each of the Synoptic Evangelists and the issue of unity and diversity in the New Testament—written, respectively, by R. T. France and David Wenham.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0